import styled, { keyframes } from "styled-components";

const animacao = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const modalAnima = keyframes`
  from {
    opacity: 0.5;
  }

  50% {
    transform: scale(1.5);
  }

  to {
    opacity: 1;
  }
`;

export const Wrapper = styled.section`
  position: relative;
  width: 100%;
  animation: 0.25s ${animacao};
  display: flex;
  flex-direction: column;
  font-size: 20px;

  .container {
    flex: 1;
  }

  .escurecer {
    opacity: 0.1;
  }

  .mensagem {
    padding: 20px 0px;
  }
`;

export const Mensagem = styled.div`
  width: calc(100% - 80px);
  position: fixed;
  z-index: 99;
  top: 0;
  margin-top: 35vh;
  padding: 20px;
  background: #666666f2;
  border-radius: 0.25rem;
  transition: all 0.25s;
  animation: 0.25s ${modalAnima};

  button {
    font-size: 16px;
  }

  @media (min-width: 350px) {
    max-width: 300px;

    button {
      font-size: 20px;
    }
  }
`;
